import script from "./comment-actions-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./comment-actions-menu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__